import { useEffect } from 'react'

/**
 * While a native map view is mounted behind the webview (iOS MKMapView or the
 * Android Google Map), make body + #root transparent so the map shows through.
 * Restores the previous backgrounds on unmount.
 */
export function useTransparentAppBackground() {
  useEffect(() => {
    const body = document.body
    const root = document.getElementById('root')
    const prevBody = body.style.backgroundColor
    const prevRoot = root?.style.backgroundColor
    body.style.backgroundColor = 'transparent'
    if (root) root.style.backgroundColor = 'transparent'

    return () => {
      body.style.backgroundColor = prevBody
      if (root) root.style.backgroundColor = prevRoot ?? ''
    }
  }, [])
}
